<template>
  <div class="animated revealUp">
    <div class="white-wrapper" style="zoom: 0.9">
      <div class="section-title">
        {{ $t("Product Sales Report") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-4 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("To Date") }}
                </label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getProductSalesReport()"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>

          <div
            v-if="ProductSalesRecords.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->

            <a
              target="_blank"
              @click="getProductSalesReport('Y', 'N')"
              title="Download as Excel"
              download
              style="cursor: pointer;"
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
            <a
                target="_blank"
                @click="getProductSalesReport('N', 'Y')"
                title="Download as PDF"
                download
                style="cursor: pointer;"
              >
                <img
                  class="mx-1"
                  src="@/assets/img/icons/pdf.svg"
                  height="25"
                  width="25"
                />
              </a>
          </div>
        </div>
      </div>
      <div class="swc-report">
        <!-- Maskewaari Report -->
        <table class="swc-report-table w-100 mt-2" border="1">
          <tr class="bg-lightgrey font-weight-bold">
            <td class="text-left">Sales Point</td>
            <td class="text-left">Name</td>
            <td class="text-left">Quantity</td>
            <td class="text-left">Net Sum</td>
            <td class="text-left">VAT (13%)</td>
            <td class="text-left">Total Gross Sum</td>
            <td class="text-left">Product Category</td>
          </tr>
          <template v-if="ProductSalesRecords.length > 0">
            <tr
              v-for="(singleProduct, index) in ProductSalesRecords"
              :key="index"
            >
              <td class="text-left">
                {{
                  singleProduct["hardware_name"] || "Central Cinema Concession"
                }}
              </td>
              <td class="text-left">
                {{
                  singleProduct["item_name"] ||
                  singleProduct["fst_item_name"] ||
                  ""
                }}
              </td>
              <td class="text-right">
                {{ parseInt(singleProduct["fst_quantity"]) }}
              </td>
              <td class="text-right">
                {{ +parseFloat(singleProduct["net_amount"] || 0).toFixed(MIN_FRACTION_DIGITS) }}
              </td>
              <td class="text-right">
                {{ +parseFloat(singleProduct["tax_amount"] || 0).toFixed(MIN_FRACTION_DIGITS) }}
              </td>
              <td class="text-right">
                {{ +parseFloat(singleProduct["gross_amount"] || 0).toFixed(MIN_FRACTION_DIGITS) }}
              </td>
              <td class="text-left">
                {{ singleProduct["fc_category"] || "Miscellaneous" }}
              </td>
            </tr>
            <tr class="bg-lightgrey font-weight-bold">
              <td class="text-left" colspan="2">Total</td>
              <td class="text-left">
                {{
                  parseInt(
                    ProductSalesRecords.reduce((acc, { fst_quantity }) => {
                      return acc + parseInt(fst_quantity);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-left">
                {{
                  currFormat(
                    ProductSalesRecords.reduce((acc, { net_amount }) => {
                      return acc + +parseFloat(net_amount || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-left">
                {{
                  currFormat(
                    ProductSalesRecords.reduce((acc, { tax_amount }) => {
                      return acc + +parseFloat(tax_amount || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-left">
                {{
                  currFormat(
                    ProductSalesRecords.reduce((acc, { gross_amount }) => {
                      return acc + +parseFloat(gross_amount || 0);
                    }, 0)
                  )
                }}
              </td>
              <td></td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="15">
                <NoRecords />
              </td>
            </tr>
          </template>
        </table>
        <!-- PRODUCT Report -->
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      ProductSalesRecords: [],
      excelFilePath: "",
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.getCinemaList(obj);
  },
  watch: {
    excelFilePath(value) {
      this.excelFilePath = value;
    },
  },
  mounted() {},
  methods: {
    moment,
    getCinemaList: function (cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getProductSalesReport(isExcelDownload = "N", isPdf = "N") {
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      } else if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      } else if (!this.toDate) {
        return this.$toasted.show("Select To Date");
      } else if (
        moment(moment(this.toDate).format("YYYY-MM-DD")).isBefore(
          moment(this.fromDate).format("YYYY-MM-DD")
        )
      ) {
        return this.$toasted.show("Please Select Valid Date Range");
      } else {
        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName || "",
          cinema_address: this.dropDown.selectedCinema.cine_address || "",
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          isPdf: isPdf
        };

        if (isExcelDownload == "Y") {
          payload["isExcel"] = "Y";
        }
        ReportsService.getProductSalesReport(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.excelPath && isExcelDownload == "Y") {
              window.open(data.excelPath, "_blank");
            }
            if (data.status && data.pdfPath && isPdf == "Y") {
              window.open(data.pdfPath, "_blank");
            } else if (data.status && data.Records.length > 0) {
              this.ProductSalesRecords = [...data.Records];
            } else {
              this.$toasted.show(data.message);
            }
            loader.hide();
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      }
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}
.swc-report-table td {
  white-space: nowrap;
}
.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/ProductSalesReport.vue